import { NewDocument } from 'pages/Finance/Components/Financing/Confirming/components/Simulator/components/DocumentSelector/components/AddDocumentsConfirming';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getDocumentsAvailableForConfirming = async (
  dispatch: Dispatch,
  data: any,
  query: string,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/confirming/documents/available?${query}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const createConfirmingOperation = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/confirming/request`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const editConfirmingOperation = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/confirming/request`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getConfirmingRequests = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/confirming?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getConfirmingRequestById = async (
  dispatch: Dispatch,
  id: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/confirming/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getMissingConfirmingApprovals = async (
  dispatch: Dispatch,
  id: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/confirming/missingApprovals/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getOperationsMissingConfirmingApprovals = async (
  dispatch: Dispatch,
  id: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/confirming/operations/missingApprovals/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getConfirmingApprovals = async (dispatch: Dispatch, id: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/confirming/approvals/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteConfirmingApproval = async (
  dispatch: Dispatch,
  id: any,
  approvalId: any,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/confirming/approvals/${id}/${approvalId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const editConfirmingRequestComitee = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/confirming/comitee/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const editOperationsConfirmingRequestComitee = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/confirming/comitee/operations/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const approveConfirmingRequest = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/confirming/comitee/approve`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const rejectConfirmingRequest = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/confirming/comitee/reject`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const approveOperationsConfirmingRequest = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/confirming/comitee/operations/approve`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const rejectOperationsConfirmingRequest = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/confirming/comitee/operations/reject`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getClientsBankAccounts = async (
  dispatch: Dispatch,
  clients: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/confirming/clients/bankAccounts`,
    data: clients,
    dispatch,
  });
  if (response) return response.data;
};

export const savePayments = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/confirming/payments/${data.id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const executeConfirmingPayments = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/confirming/payments/execute/${data.id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const updateStatusConfirmingRequest = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/confirming/request/updateStatus/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const createDocumentsConfirming = async (
  dispatch: Dispatch,
  data: {
    documents: NewDocument[];
    stakeholderIdentifier: string;
  },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/confirming/documents/create`,
    data,
    dispatch,
  });
  if (response) return response.data;
};
